import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Login from './Login';
import Inicio from './principales/Inicio/Inicio';
import Principal from './principales/Principal';
import Usuarios from './secundarios/Usuarios/Usuarios';
import ProtectedRoute from './ProtectedRoute';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Ruta pública (Login) */}
        <Route path="/login" element={<Login />} />

        {/* Rutas protegidas */}
        <Route path="/inicio" element={<ProtectedRoute />}>
          <Route element={<Inicio />}>
            <Route index element={<Principal />} />
            <Route path="principal" element={<Principal />} />
            <Route path="usuarios" element={<Usuarios />} />
          </Route>
        </Route>

        {/* Redirección por defecto */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
